/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_Api_KeysInputs */



/**
* | output |
* | --- |
* | "Generate API keys for programmatic access to oneAI." |
*
* @param {Plan_Gate_Desc_Api_KeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_api_keys = /** @type {((inputs?: Plan_Gate_Desc_Api_KeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_Api_KeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie API-Schlüssel für den programmatischen Zugriff auf oneAI.")
	return /** @type {LocalizedString} */ ("Generate API keys for programmatic access to oneAI.")
});